import firefly from '../assets/images/firefly.png';
import snowflake from '../assets/images/snowflake.png';

export const FIREFLY_PARTICLES: any = {
  number: {
    value: 320,
    density: {
      enable: false,
    }
  },
  color: {
    value: '#fff'
  },
  shape: {
    type: "image",
    stroke: {
      width: 3,
      color: "#fff"
    },
    polygon: {
      nb_sides: 5
    },
    image: {
      src: firefly,
      width: 100,
      height: 100
    }
  },
  opacity: {
    value: 1,
    random: true,
    anim: {
      enable: false,
      speed: 1,
      opacity_min: 0.5,
      sync: false
    }
  },
  // fixed random size from 0 to 5 for each participle (no size animation)
  size: {
    value: 20,
    random: true,
    anim: {
      enable: false,
    }
  },
  // participles are not connected with lines
  lineLinked: {
    enable: false,
  },
  move: {
    vibrate: true,
    size: true,
    distance: 16,
    enable: true,
    speed: 1.4,
    warp: false,
    random: true,
    direction: 'bottom',
    straight: false,
    out_mode: 'out',
  }
};

export const SNOWFLAKE_PARTICLES: any = {
  number: {
    value: 250,
    density: {
      enable: false,
    }
  },
  color: {
    value: '#fff'
  },
  shape: {
    type: "image",
    stroke: {
      width: 3,
      color: "#fff"
    },
    polygon: {
      nb_sides: 5
    },
    image: {
      src: snowflake
    }
  },
  opacity: {
    value: 0.8,
    random: true,
    anim: {
      enable: false,
      speed: 1,
      opacity_min: 0.5,
      sync: false,
    }
  },
  // fixed random size from 0 to 5 for each participle (no size animation)
  size: {
    value: 28,
    random: {
      enable: true,
      minimumValue: 4,
    },
    anim: {
      enable: false,
    }
  },
  // participles are not connected with lines
  lineLinked: {
    enable: false,
  },
  move: {
    angle: {
      offset: -5,
      value: 35,
    },
    enable: true,
    speed: 2.4,
    warp: false,
    random: false,
    direction: 'bottom',
    straight: false,
    out_mode: 'out',
  },
};

export const INTERACTIVITY: any = {
  detect_on: 'canvas',
  events: {
    onhover: {
      enable: true,
      mode: 'repulse',
    },
    resize: true
  },
  modes: {
    repulse: {
      distance: 40,
      duration: 0.5,
      speed: 0.05,
      maxSpeed: 1,
      factor: 200,
    },
  }
};
